import common_product_pro from './common_product_pro'
cb.define([], function() {
    var PC_pc_productbrandpro_VM_Extend = {
        doAction: function(name, viewmodel) {
            if (this[name]) {
                this[name](viewmodel);
            }
        },
        init: function(viewmodel) {
            common_product_pro(viewmodel)
        },
    }
    try {
        module.exports = PC_pc_productbrandpro_VM_Extend;
    } catch (error) {
        // 当 类型 为 档案 的时候
    }
    return PC_pc_productbrandpro_VM_Extend;
});


// WEBPACK FOOTER //
// ./src/client/business/PC/PC_pc_productbrandpro_VM.Extend.js